import { Component, OnInit } from '@angular/core';
import { OfferLogicService } from '../../logic/offer.service';
import { AddOfferModel } from '../../interfaces/interfaces';
import { PassDataService } from '../../services/pass-data.service';

@Component({
  selector: 'add-offer-pg',
  templateUrl: './add-offer.component.html',
})
export class AddOfferPage implements OnInit {
  offerUrl: string = '';
  add: string = 'Add';
  isEdit: boolean = true;
  url: string = '';
  _id: string = '';
  private file: any = null;

  constructor(
    private offerLogicService: OfferLogicService,
    private passDataService: PassDataService
  ) {}

  ngOnInit(): void {}

  imageFileOutput(file: any) {
    this.file = file;
  }

  setUrl(url: string) {
    this.url = url;
  }

  onAddClick() {
    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Adding offer, please wait!',
    });

    if (this.file == null) {
      this.passDataService.setPopup({
        isPopup: true,
        message: 'Image is mandatory!',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
      return;
    }

    if (this.url == '') this.url = 'no-url';

    this.offerLogicService
      .addOfferLogic(this.url, this.file != null ? this.file.item(0) : null)
      .subscribe((v: any) => {
        this.url = '';
        this.file = null;

        this.passDataService.setPopup({
          isPopup: true,
          message: v.message,
          isOk: true,
          isDelete: false,
          isLoading: false,
          loadingMessage: '',
        });
      });
  }
}
